export default __webpack_public_path__ + "static/media/instagram-feed.c04d1f38.jpg";